<template>
  <!-- ##### Footer Area Start ##### -->
    <footer class="footer-area">
        <!-- Main Footer Area -->
        <div class="main-footer-area section-padding-100-0 bg-img foo-bg-overlay" :style="'background-image: url(' + require('@/assets/slider/1.jpg') +');'">
            <div class="container">
                <div class="row">
                    <!-- Footer Widget Area -->
                    <div class="col-12 col-sm-4">
                        <div class="d-flex flex-wrap mb-100">
                            <div class="footer-widget">
                                <div class="widget-title">
                                    <a href="#"><img src="@/assets/logo2.png" width="150" alt=""></a>
                                </div>
                                <div class="footer-social-info">
                                    <!-- <a href="#"><i class="fa fa-google-plus"></i></a>
                                    <a href="#"><i class="fa fa-pinterest"></i></a>
                                    <a href="#"><i class="fa fa-facebook"></i></a>
                                    <a href="#"><i class="fa fa-twitter"></i></a> -->
                                </div>
                            </div>
                            <div class="copywrite-text">
                                <p>Copyright &copy;{{year}} All rights reserved </p>
                            </div>
                        </div>
                    </div>

                    <!-- Footer Widget Area -->
                    <div class="col-12 col-sm-5">
                        <div class="footer-widget mb-100">
                            <div class="widget-title">
                                <h6>Contacto</h6>
                            </div>

                            <!-- Single Contact Area -->
                            <div class="single-contact-area mb-30">
                                <p>Dirección:</p>
                                <span> 631 E Adams Blvd, Los Angeles, <br>CA 90011, EE. UU. </span>
                            </div>

                            <!-- Single Contact Area -->
                            <div class="single-contact-area mb-30">
                                <p>Teléfono:</p>                                
                                <span>+1 (626) 808-1237</span>
                            </div>

                            <!-- Single Contact Area -->
                            <div class="single-contact-area mb-30">
                                <p>Email:</p>
                                <span>lasendaantigua.la@gmail.com</span>
                            </div>
                        </div>
                    </div>

                    <!-- Footer Widget Area -->
                    <div class="col-12 col-sm-3 ">
                        <div class="footer-widget mb-100">
                            <div class="widget-title">
                                <h6>Links</h6>
                            </div>
                            <nav>
                                <ul class="useful-links">
                                    <li><a href="/">Inicio</a></li>
                                    <li><a href="/missions">Misiones</a></li>
                                    <li><a href="/radio">Radio</a></li>
                                    <li><a href="/bq">BQ</a></li>
                                    <li><a href="/missions">Donaciones</a></li>
                                    <li><a href="/contact">Contacto</a></li>
                                </ul>
                            </nav>
                        </div>
                    </div>

                    <!-- Footer Widget Area -->
                    <!-- <div class="col-12 col-sm-6 col-xl-3">
                        <div class="footer-widget mb-100">
                            <div class="widget-title">
                                <h6>Servicios En Vivo</h6>
                            </div>
                            <p>
                                Sea parte de nuestros servicios. <br>
                                Bienvenido a nuestra transmisión en vivo. Esperamos que Dios pueda tocar su corazón y pueda unirse a nosotros en alabanza y adoración a nuestro Dios. Le invitamos también a visitar nuestra sección de sermones anteriores                                
                            </p>
                            <a href="https://youtu.be/XoqNLYQGiOg" target="_blank" class="btn faith-btn mt-70">Domingo: 10:30 AM</a>
                        </div>
                    </div> -->
                </div>
            </div>
        </div>
    </footer>
    <!-- ##### Footer Area Start ##### -->
</template>

<script>
export default {
  data() {
    return {
      year: "",
    };
  },
  mounted() {
    this.year = new Date().getFullYear();
  },
};
</script>

<style>
</style>